<template>
    <div id='home' :class="[flag?bg_class_one:bg_class_two]">
    </div>
</template>

<script>
    module.exports = {
        name: 'Home',
        data() {
            return {
                flag: true,
                bg_class_one: 'bg_class_one',
                bg_class_two: 'bg_class_two'
            }
        },
        created() {
            var interval =  new Date('2022-02-04 10:00:00').getTime() - new Date().getTime() 
            setTimeout(()=>{
                this.flag = false
            },interval)
        },
        mounted() {
            function fit_block() {
                var ele = document.documentElement;
                var w = 1920;
                var width = ele.clientWidth < 1366 ? 1366 : ele.clientWidth
                var scaleX = width > 1920 ? 1 : (width / 1920)
                var app = document.querySelector("#app").style
                var home = document.querySelector("#home").style
                home.width = width + "px"
                app.width = width + "px"
                // if(width>1366){
                //     // ele.height = clientHeight / scaleX + 'px'
                //     home.transformOrigin = '0px 0px 0px'
                //     home.webkitTransformOrigin = '0px 0px 0px'
                //     home.transform = 'scale(' + scaleX + ')'
                //     home.webkitTransform = 'scale(' + scaleX + ')'
                //     home.display = 'block'
                // }
            }

            window.onresize = function () {
                fit_block()
            }
            
        },
        methods: {

        },
        computed: {

        }

    }
</script>

<style scoped>
    #home {
        top: 0;
        left: 0;
        width: 100%;
        height: 3384px;
        /* min-width: 1400px; */
        z-index: -10;
        zoom: 1;
        /* background-image: url('https://r.syyx.com/party/nycs/2022_spring_festival/home_bg.jpg'); */
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
    }

    .bg_class_one {
        background-image: url('https://r.syyx.com/party/nycs/2022_spring_festival/home_bg_one.jpg');
    }

    .bg_class_two {
        background-image: url('https://r.syyx.com/party/nycs/2022_spring_festival/home_bg_two.jpg');
    }
</style>